/*eslint-disable*/
const mandateTypes = [
    { value: "open", label: "Open", },
    { value: "sole", label: "Sole", },
    { value: "none", label: "None", },
    { value: "company listing", label: "Company Listing", },
    { value: "shared", label: "Shared", },
    { value: "referral", label: "Referral", }
];

const usageTypes = [
    { value: "Commercial", label: "Commercial", },
    { value: "Industrial", label: "Industrial", },
];

const listingTypes = [
    { value: "tolet", label: "To Let" },
    { value: "sale", label: "For Sale" }
];

const titleTypes = [
    { value: "Freehold", label: "Freehold" },
    { value: "Sectional Title", label: "Sectional Title" },
    { value: "None", label: "None" },
    { value: "Share Block", label: "Share Block" }
];

const availabilityTypes = [
    { value: "Immediate", label: "Immediate" },
    { value: "Negotiable", label: "Negotiable" },
    { value: "Specific Date", label: "Specific Date" },
];

const availableFromOptions = [
    { label: "Immediately", value: "Immediately" },
    { label: "Negotiable", value: "Negotiable" },
    { label: "Specific Date", value: "Specific Date" }
];
const leasePeriods = [
    { label: "1 month", value: "1 months" },
    { label: "2 months", value: "2 months" },
    { label: "3 months", value: "3 months" },
    { label: "6 months", value: "6 months" },
    { label: "9 months", value: "9 months" },
    { label: "12 months", value: "12 months" },
    { label: "24 months", value: "24 months" },
    { label: "36 months", value: "36 months" },
    { label: "48 months", value: "48 months" },
    { label: "60 months", value: "60 months" },
    { label: "Negotiable", value: "Negotiable" }
];

const leaseTypes = [
    { label: "Percentage", value: "Percentage" },
    { label: "Net", value: "Net" },
    { label: "Double Net", value: "DoubleNet" },
    { label: "Triple Net", value: "TripleNet" },
    { label: "Fully Serviced Lease Gross", value: "FullyServicedLeaseGross" }
]
const buildingGrades = [
    { value: "A", label: "A" },
    { value: "AAA", label: "AAA" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "P", label: "P" }

];
const locationOptions = [
    { value: "address", label: "Address" },
    { value: "suburb", label: "Suburb" },
];
const truckAccessOptions = [
    { value: "Small_Trucks", label: "Small Trucks" },
    { value: "Single_Trailer", label: "Single Trailer" },
    { value: "Interlink", label: "Interlink" },
    { value: "Superlink", label: "Superlink" }
];


    export {truckAccessOptions,locationOptions,buildingGrades,leaseTypes,leasePeriods,availableFromOptions,availabilityTypes,titleTypes,listingTypes,usageTypes,mandateTypes}